import { Box, Text } from '@chakra-ui/react';
import React from 'react';

const QuoteBox = ({ quote }) => {
  if (!quote) return null;

  return (
    <Box
      position="relative"
      m={4}
      p={4}
      bg="green.50"
      display={'flex'}
      justifyContent={'center'}
      borderColor="green.500"
      rounded="md"
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        color="green.300"
        fontSize="4xl"
        fontFamily="serif"
        pl={1}
      >
        “
      </Box>
      <Text
        className="line-clamp-4"
        fontWeight="medium"
        color="gray.700"
        position="relative"
        display="inline-block"
        maxWidth="100%"
        title={quote}
        ml={3}
      >
        {quote}
      </Text>
      <Box
        position="absolute"
        display="flex"
        alignItems={'flex-end'}
        right={2}
        bottom={0}
        color="green.300"
        fontSize="4xl"
        fontFamily="serif"
      >
        „
      </Box>
    </Box>
  );
};

export default QuoteBox;
